document.addEventListener('DOMContentLoaded', function() {
    const targetIds = ["7231997706374", "7231804178566", "7231976964230"];
    const requiredProductId = "7227910914182";
    const requiredProductIdSecond = "7071984189574";

    function checkAndRemoveItems() {
      fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
              const cartItems = cart.items;
              const hasRequiredProduct = cartItems.some(item => item.product_id.toString() === requiredProductId);
              const hasRequiredProductSecond = cartItems.some(item => item.product_id.toString() === requiredProductIdSecond);
              const targetProductKeys = cartItems
                  .filter(item => targetIds.includes(item.product_id.toString()))
                  .map(item => item.key);

            console.log('hasRequiredProduct', hasRequiredProduct)
            console.log('hasRequiredProductSecond', hasRequiredProductSecond)
              if (targetProductKeys.length > 0 && (!hasRequiredProduct || !hasRequiredProductSecond)) {
                  const updates = {};
                  targetProductKeys.forEach(key => {
                      updates[key] = 0;
                  });

                  fetch(`/cart/update.js`, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ updates })
                  })
                  .then(response => response.json())
                  .then(cart => {
                      location.reload();
                  })
                  .catch(error => {
                      console.error('Error updating the cart:', error);
                  });
              }
          })
          .catch(error => {
              console.error('Error fetching cart data:', error);
          });
    }

  checkAndRemoveItems();

  document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
    checkAndRemoveItems();
  });

});
